import { useNavigate } from "react-router";
import BaseComponent from "../../../shared/baseComponent/BaseComponent";
import { useApiClient } from "../../../shared/customHooks";
import { kindergartenScreeningQuestionsForm } from "../../../shared/formObjects/application/kindergartenScreeningQuestionsForm";
import { useApplicationContext } from "../context/applicationContext";
import { useAccount, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { BrowserAuthError, InteractionRequiredAuthError } from "@azure/msal-browser";
import { useCallback } from "react";
import { useGlobalContext } from "../../../shared/GlobalContext";

function KindergartenScreeningComponent({ disabled, data }: any) {
  const api = useApiClient("KindergartenInitialApplication");
  const { id } = useApplicationContext();
  const navigate = useNavigate();
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { addLoadingUrl, removeLoadedUrl, accountInfo } = useGlobalContext();

  const refreshToken = useCallback(async () => {
    if (!account) {
      throw new Error("No account available");
    }
    const accessTokenRequest = {
      scopes: loginRequest.scopes,
      account: account,
      forceRefresh: true,
    };
    const res = await instance.acquireTokenSilent(accessTokenRequest).catch(async (error) => {
      if (error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) {
        if (account && (inProgress === "none" || inProgress === "startup")) {
          return await instance.acquireTokenRedirect({
            scopes: loginRequest.scopes,
          });
        }
      }
    });
    return res;
  }, [[instance, account, inProgress]]);

  const AddUserLinkToToken = async (res: any) => {
    addLoadingUrl("UserLinkLogic");
    await refreshToken().then(() => {
      if (accountInfo.isKindergarten) {
        navigate("/kindergarten/pendingApplications/" + res.record.id, { relative: "path" });
      } else if (accountInfo.isAssessorOrManager || accountInfo.isRoot) {
        navigate("/presubmission/" + res.record.id, { relative: "path" });
      }
    });
    removeLoadedUrl("UserLinkLogic");
  };

  return (
    <BaseComponent
      formBody={kindergartenScreeningQuestionsForm(navigate)}
      headerLabel="Screening questions"
      editPath="screeningQuestions"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      showInternalNotes={false}
      hideCancelButton={true}
      hideSubmitButton={true}
      saveSuccessCB={(res) => {
        AddUserLinkToToken(res);
      }}
      submitPath={null}
    />
  );
}

export default KindergartenScreeningComponent;
